import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Box, Typography, Button, Paper, Alert } from '@mui/material';
import { Refresh, Delete } from '@mui/icons-material';

const DebugAuth = () => {
  const { user, token, isAuthenticated } = useAuth();

  const handleClearAllStorage = () => {
    localStorage.clear();
    sessionStorage.clear();
    if (window.caches) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
    // Force immediate redirect
    window.location.replace('/#/login');
  };

  const handleForceLogout = () => {
    // Same as clear all storage - nuclear option
    handleClearAllStorage();
  };

  return (
    <Paper elevation={3} sx={{ p: 3, m: 2, maxWidth: 600 }}>
      <Typography variant="h6" gutterBottom>
        🔍 Authentication Debug Info
      </Typography>
      
      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" color="text.secondary">
          <strong>Is Authenticated:</strong> {isAuthenticated ? 'Yes' : 'No'}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>User Type:</strong> {user?.userType || 'None'}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>User ID:</strong> {user?.id || 'None'}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>Token Present:</strong> {token ? 'Yes' : 'No'}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>LocalStorage Token:</strong> {localStorage.getItem('token') ? 'Yes' : 'No'}
        </Typography>
      </Box>

      {token && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Token Payload:</strong>
          </Typography>
          <pre style={{ fontSize: '12px', background: '#f5f5f5', padding: '8px', borderRadius: '4px', overflow: 'auto' }}>
            {JSON.stringify(JSON.parse(atob(token.split('.')[1])), null, 2)}
          </pre>
        </Box>
      )}

      <Alert severity="warning" sx={{ mb: 2 }}>
        If you're seeing the wrong user type, try the buttons below to clear all data.
      </Alert>

      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <Button
          variant="outlined"
          startIcon={<Refresh />}
          onClick={() => window.location.reload()}
        >
          Refresh Page
        </Button>
        
        <Button
          variant="outlined"
          color="error"
          startIcon={<Delete />}
          onClick={handleClearAllStorage}
        >
          Clear All Storage
        </Button>
        
        <Button
          variant="contained"
          color="error"
          onClick={handleForceLogout}
        >
          Force Logout
        </Button>
      </Box>
    </Paper>
  );
};

export default DebugAuth;
